<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <div class="row">
                        <CCol sm="6" class="align-self-center">
                            <strong>{{ $lang.candidateRequest.title }}</strong>
                        </CCol>
                    </div>
                </CCardHeader>
                <CCardBody>
                    <CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>{{ err_msg }}</CAlert>

                    <CRow>
                        <CCol md="12">
                            <CRow>
                                <CCol md="12" class="text-left">
                                    <p class="custome-labal">
                                        <strong>
                                            {{ requestData.directCandidate && requestData.directCandidate.firstName ? requestData.directCandidate.firstName : '' }}
                                            {{ requestData.directCandidate && requestData.directCandidate.lastName ? requestData.directCandidate.lastName : '' }}
                                        </strong>
                                    </p>
                                </CCol>
                                <CCol md="12" class="text-left">
                                    <p class="text-center"><b>Identification Documents (User)</b></p>
                                    <table class="table table-striped table-bordered table-hover">
                                        <thead>
                                            <th>Document Type</th>
                                            <th>Number</th>
                                            <th>Actions</th>
                                        </thead>
                                        <tbody>
                                            <tr :key="requestData.id">
                                                <td>GST</td>
                                                <td>{{ requestData.gstNumber }}</td>
                                                <td>
                                                    <CButton color="dark" size="sm" v-if="requestData.isGstNumberVerified === 0" @click="checkIdentity(requestData.id, requestData.gstNumber, 'user')">Check</CButton>
                                                    <CButton color="info" size="sm" v-if="requestData.isGstNumberVerified === 0" @click="verifyIdentity(requestData.id)">Verify</CButton>
                                                    <CButton color="success" size="sm" v-if="requestData.isGstNumberVerified === 1">Verified</CButton>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </CCol>
                            </CRow>
                        </CCol>

                        <CCol md="12">
                            <CRow>
                                <CCol md="12">
                                    <div class="accordion">
                                        <div v-for="(transaction, index) in requestData.requestTransaction" :key="index" class="accordion-item">
                                            <div class="accordion-header" @click="toggle(index)">
                                                <div>
                                                    <b>{{ getModuleLabel(transaction.moduleType) }}</b>
                                                    <CBadge class="m-l-20" :color="getStatusColor(transaction.isVerified)">{{ transaction.isVerified }}</CBadge>
                                                </div>
                                                <span v-if="activeIndex === index">-</span>
                                                <span v-else>+</span>
                                            </div>

                                            <transition name="accordion">
                                                <div class="accordion-content" v-if="activeIndex === index">
                                                    <CRow>

                                                        <!-- Headline & Years of Experience -->
                                                        <CCol md="6" class="p-1" v-if="transaction.headline">
                                                            <b>Headline:</b> {{ transaction.headline }}
                                                        </CCol>

                                                        <CCol md="6" class="p-1" v-if="transaction.yearsOfExperience">
                                                            <b>Years of Experience:</b> {{ transaction.yearsOfExperience }}
                                                        </CCol>

                                                        <!-- Contribution Motivation -->
                                                        <CCol md="12" class="p-1" v-if="transaction.contributionMotivation">
                                                            <b>Contribution Motivation:</b> {{ transaction.contributionMotivation }}
                                                        </CCol>

                                                        <!-- What People Can Learn -->
                                                        <CCol md="12" class="p-1" v-if="transaction.whatPeopleCanLearn">
                                                            <b>What People Can Learn:</b> {{ transaction.whatPeopleCanLearn }}
                                                        </CCol>

                                                        <!-- Has Contribution Experience -->
                                                        <CCol md="6" class="p-1" v-if="transaction.hasContributionExperience !== null && transaction.hasContributionExperience !== undefined">
                                                            <b>Has Contribution Experience:</b>
                                                            <CBadge :color="transaction.hasContributionExperience ? 'success' : 'secondary'">
                                                                {{ transaction.hasContributionExperience ? 'Yes' : 'No' }}
                                                            </CBadge>
                                                        </CCol>

                                                        <!-- Contribution Journey — only when hasContributionExperience is true -->
                                                        <CCol md="12" class="p-1" v-if="transaction.hasContributionExperience && transaction.contributionJourney">
                                                            <b>Contribution Journey:</b> {{ transaction.contributionJourney }}
                                                        </CCol>

                                                        <!-- Support Targets — nested supportTargetMaster.title -->
                                                        <CCol md="6" class="p-1" v-if="transaction.supportTargets && transaction.supportTargets.length">
                                                            <b>Who Would You Like to Support:</b>
                                                            <ul>
                                                                <li v-for="target in transaction.supportTargets" :key="target.id">
                                                                    {{ target.supportTargetMaster ? target.supportTargetMaster.title : '' }}
                                                                </li>
                                                            </ul>
                                                        </CCol>

                                                        <!-- Areas of Expertise — nested areasOfExpertiseMaster.title -->
                                                        <CCol md="6" class="p-1" v-if="transaction.areasOfExpertise && transaction.areasOfExpertise.length">
                                                            <b>Areas of Expertise:</b>
                                                            <ul>
                                                                <li v-for="area in transaction.areasOfExpertise" :key="area.id">
                                                                    {{ area.areasOfExpertiseMaster ? area.areasOfExpertiseMaster.title : '' }}
                                                                </li>
                                                            </ul>
                                                        </CCol>

                                                        <!-- Industry -->
                                                        <CCol md="6" class="p-1" v-if="transaction.industry && transaction.industry.length">
                                                            <b>{{ $lang.candidateRequest.industry }}:</b>
                                                            <div v-for="industry in transaction.industry" :key="industry.id" class="industry" style="padding-left: 10px;">
                                                                <p style="margin-bottom:0;">{{ industry.industryTitle.title }}</p>
                                                                <ul>
                                                                    <li v-for="skill in industry.expertiseSkills" :key="skill.id">
                                                                        {{ skill.skill.title }}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </CCol>

                                                        <!-- Groups -->
                                                        <CCol md="6" class="p-1" v-if="transaction.groups && transaction.groups.length">
                                                            <b>{{ $lang.candidateRequest.groups }}:</b>
                                                            <ul>
                                                                <li v-for="group in transaction.groups" :key="group.id">
                                                                    {{ group.categoryTitle.title }}
                                                                </li>
                                                            </ul>
                                                        </CCol>

                                                        <!-- Description -->
                                                        <CCol md="12" class="p-1" v-if="transaction.description">
                                                            <b>{{ $lang.candidateRequest.description }}:</b> {{ transaction.description }}
                                                        </CCol>

                                                        <!-- Reference Links — response returns {link, dcRequestTransactionId} objects -->
                                                        <CCol md="12" class="p-1" v-if="transaction.referenceLink && transaction.referenceLink.length">
                                                            <b>{{ $lang.candidateRequest.referenceLink }}:</b>
                                                            <ul>
                                                                <li v-for="(ref, i) in transaction.referenceLink" :key="i">
                                                                    <a :href="ref.link" target="_blank">{{ ref.link }}</a>
                                                                </li>
                                                            </ul>
                                                        </CCol>

                                                        <!-- Block Reason -->
                                                        <CCol md="12" class="p-1" v-if="transaction.blockReason">
                                                            <b>{{ $lang.candidateRequest.blockReason }}:</b> {{ transaction.blockReason }}
                                                        </CCol>

                                                        <!-- Rejection Reason -->
                                                        <CCol md="12" class="p-1" v-if="transaction.reasonRejection">
                                                            <b>{{ $lang.candidateRequest.rejectionReason }}:</b> {{ transaction.reasonRejection }}
                                                        </CCol>

                                                        <!-- Action Buttons -->
                                                        <CCol md="12" class="p-1 text-right" v-if="transaction.isVerified === 'Pending' || transaction.isVerified === 'Verified'">
                                                            <CButton color="info" size="sm" v-if="transaction.isVerified === 'Pending'" @click="verifyRequest(transaction.id)">Verify</CButton>
                                                            <CButton class="m-l-10" color="danger" size="sm" v-if="transaction.isVerified === 'Pending'" @click="rejectRequest(transaction.id)">Reject</CButton>
                                                            <CButton class="m-l-10" color="danger" size="sm" v-if="transaction.isVerified === 'Verified'" @click="blockRequest(transaction.id)">Block</CButton>
                                                        </CCol>

                                                    </CRow>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </CCol>

        <CCol col="12">
            <CModal :title="$lang.common.general.reason" size="lg" :show.sync="largeModal" :no-close-on-backdrop="true" color="primary">
                <CCardBody>
                    <CRow>
                        <CCol md="12">
                            <c-textarea v-model="reason" :rows="5" :cols="10" placeholder="Add Reason"></c-textarea>
                        </CCol>
                    </CRow>
                </CCardBody>
                <template #footer>
                    <CButton v-c-tooltip="$lang.buttons.general.crud.submit" color="primary" :disabled="submitted" v-on:click="submitReason()">Submit</CButton>
                </template>
            </CModal>
        </CCol>
    </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { candidateRequest } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import { Maxlength } from "../../store/maxlength";
import store from "@/store/store";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
    name: "CandidateRequest",
    mixins: [Mixin],
    data() {
        return {
            module: candidateRequest,
            candidate: {},
            messageColor: "success",
            err_msg: "",
            alertMessage: "test",
            showAlert: false,
            dismissCountDown: 0,
            dismissCountDownS: 0,
            requestData: [],
            activeIndex: 0,
            largeModal: false,
            submitted: false,
            selectedId: null,
            selectedStatus: null,
            reason:null,
            maxlength: {
                title: Maxlength.candidate.title,
            },
            moduleType: [{
                "value": 1,
                "label": "Plant Dreams",
            },
            {
                "value": 2,
                "label": "Mentoring Mind",
            },
            {
                "value": 3,
                "label": "Interviewer",
            },
            {
                "value": 4,
                "label": "Assignments (Non-Profit Tasks)",
            },
            {
                "value": 6,
                "label": "Corporate Coach",
            },
            {
                "value": 5,
                "label": "Book Donate",
            }
            ]
        };
    },
    mounted() {
        this.loadData();
        store.commit('showLoader', false);
        this.dismissCountDown = 0;
        this.dismissCountDownS = 0;
        if (localStorage.getItem("showAlert") !== "") {
            this.setAlert(true);
        }
        this.setAlert(false);
        localStorage.setItem("showAlert", "");
    },
    methods: {
        toggle(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        },
        setAlert(value) {
            this.showAlert = value;
        },
        loadData() {
            let self = this;
            axios.get(self.viewUrlApi(self.module, self.$route.params.id))
                .then(function (response) {
                    if (response) {
                        self.requestData = response.data.data;
                    }
                });
        },
        getModuleLabel(value) {
            const module = this.moduleType.find(mod => mod.value === value);
            return module ? module.label : "Unknown Module";
        },
        getStatusColor(value) {
            switch (value) {
                case 'Pending':
                    return 'warning';
                case 'Verified':
                    return 'success';
                case 'Rejected':
                case 'Expired':
                case 'Blocked':
                    return 'danger';
                default:
                    return 'info';
            }
        },
        verifyRequest(id) {
            // Handle verify request logic
            this.selectedId = id;
            this.selectedStatus = "Verified";
            this.reason = "";
            this.submitReason();
        },
        rejectRequest(id) {
            // Handle reject request logic
            this.largeModal = true;
            this.selectedId = id;
            this.selectedStatus = "Rejected";
        },
        blockRequest(id) {
            // Handle block request logic
            this.largeModal = true;
            this.selectedId = id;
            this.selectedStatus = "Blocked";
        },
        submitReason(){
            let self = this;
            const postData = {
                is_verified: self.selectedStatus,
                reason: self.reason
            };
            axios
            .post(self.editUrlApi(self.module,self.selectedId), postData)
            .then(function (response) {
                if (response.data.code == 200) {
                    self.loadData();
                    self.largeModal = false;
                    self.reason = "";
                    self.messageColor = "success";
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                    
                    
                } else {
                    self.messageColor = "danger";
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                }
            })
            .catch(function (error) {
                localStorage.setItem("token", "");
                self.dismissCountDown = 10;
            });
        }
    },
};
</script>
<style scoped>
.accordion {
    width: 100%;
    margin: 0 auto;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
}

.accordion-item {
    border-bottom: 1px solid #ccc;
}

.accordion-header {
    background-color: #f5f5f5;
    padding: 10px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.accordion-header h3 {
    margin: 0;
}

.accordion-content {
    padding: 15px;
    background-color: #fff;
}

.accordion-enter-active,
.accordion-leave-active {
    transition: max-height 0.3s ease;
}

.accordion-enter,
.accordion-leave-to {
    max-height: 0;
    overflow: hidden;
}

.m-l-20 {
    margin-left: 20px;
}

.p-10 {
    padding: 10px;
}

.m-10 {
    margin: 10px;
}

.m-l-10 {
    margin-left: 10px;
}

.float-right {
    float: right;
}
</style>